<!-- Pre Title -->
<div edsRow *ngIf="content.preTitle">
  <div edsCol [columnNumbers]="colNumbers">
    <p class="pre-title" edsSpacing="xs">{{ content.preTitle }}</p>
  </div>
</div>
<!--Title  -->
<div edsRow>
  <eds-title
    edsSpacing="md"
    edsCol
    [columnNumbers]="colNumbers"
    [isLight]="true"
    [title]="content.title"
    [size]="'h3'"
    [level]="2"
    theme="dark"
  ></eds-title>
</div>
